<template>
  <v-card outlined :loading="loading">
    <v-card-title
      class="d-flex justify-space-between pb-0"
      v-intersect="onIntersect"
    >
      <h6 class="lh-1">Representatividade por Setor</h6>
      <v-btn-toggle mandatory v-model="display" class="ml-2">
        <v-btn small> R$ </v-btn>
        <v-btn small> Qtde </v-btn>
      </v-btn-toggle>
    </v-card-title>
    <v-card-text>
      <v-alert
        type="warning"
        dense
        class="mb-0"
        v-if="!chartSeries.length"
      >
        Nenhum pagamento válido.
      </v-alert>

      <apexCharts
        v-else
        type="donut"
        height="250"
        :options="chartOptions"
        :series="chartSeries"
      />
      <v-alert v-if="error" type="error" class="mb-0">
        {{ error }}
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import ApexCharts from "vue-apexcharts";

export default {
  components: {
    ApexCharts,
  },
  data: () => ({
    error: null,
    display: 0,
    viewed: false,
    isIntersecting: false,
    channelColors: {
      pos: "#FF4560",
      ticketOffice: "#775DD0",
      shop: "#008FFB",
      seller: "#00E396",
      unknown: "#000",
    },
    channelTranslation: {
      pos: "PDV",
      ticketOffice: "Bilheteria",
      shop: "Site",
      seller: "Promoter",
      unknown: "Externo",
    },
    colors: [
      "#008FFB",
      "#00E396",
      "#FEB019",
      "#FF4560",
      "#775DD0",
      "#3F51B5",
      "#546E7A",
      "#D4526E",
      "#8D5B4C",
      "#F86624",
      "#D7263D",
      "#1B998B",
      "#2E294E",
      "#F46036",
      "#E2C044",
    ],
  }),
  methods: {
    onIntersect(entries) {
      if (entries[0].isIntersecting) {
        this.isIntersecting = true;
        this.viewed = true;
      } else {
        this.isIntersecting = false;
      }
    },
  },
  computed: {
    ticketGroups() {
      if (!this.viewed) return {};
      const translations = {};
      const data = this.data.payments
        .filter((payment) => payment.status == "succeeded")
        .reduce((acc, p) => {
          for (const ticket of p.Ticket) {
            const tgId = ticket.TicketBlock?.TicketGroup?.id || "Sem Grupo";
            if (!acc[tgId]) {
              acc[tgId] = 0;
              translations[tgId] =
                ticket.TicketBlock?.TicketGroup?.name || "Sem Grupo";
            }
            if (this.display) acc[tgId] += 1;
            else acc[tgId] += ticket.amount - ticket.platformFee;
          }

          return acc;
        }, {});
      return {
        translations,
        data,
      };
    },
    chartSeries() {
      if (!this.ticketGroups?.data) return [];
      return Object.values(this.ticketGroups.data || {});
    },
    chartOptions() {
      const translations = this.ticketGroups.translations || {};
      return {
        chart: {
          type: "donut",
          height: 250,
        },
        legend: {
          show: true,
          position: "bottom",
          formatter: (seriesName, opts) => {
            var value = opts.w.globals.series[opts.seriesIndex];
            value = this.display
              ? `${value} ingresso${value != 1 ? "s" : ""}`
              : value.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                });
            return `${seriesName}: ${value}`;
          },
        },
        labels: Object.keys(this.ticketGroups.data || {}).map(
          (key) => translations[key] || key
        ),
        colors: this.colors,
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          labels: {
            formatter: (value) =>
              this.display
                ? `${value} ingresso${value != 1 ? "s" : ""}`
                : value.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }),
          },
        },
      };
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style></style>
